import moment from 'moment';

export const BRAND_TEAL = '#00a88e';
export const BRAND_TEAL_DIM = '#008f78';

export const PIPELINE_CHART_COLORS = [BRAND_TEAL, BRAND_TEAL_DIM, '#19d883', '#5FB489'];

export const CHART_COLORS = {
  primary: BRAND_TEAL,
  secondary: BRAND_TEAL_DIM,
  day: BRAND_TEAL,
  night: BRAND_TEAL_DIM,
  warn: '#B38600',
  bad: '#C4001F',
  orange: '#BD5730',
  grid: '#E8EAED',
  tick: '#8695A1',
  text: '#333333',
};

export const fmtMinP = (minutes) => {
  if (minutes == null || Number.isNaN(Number(minutes))) return '—';
  const m = Math.round(Number(minutes));
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (h > 0) return `${h} hr ${r} min`;
  return `${r} min`;
};

export const fmtDateGb = (iso) => {
  if (!iso) return '—';
  return moment(iso).format('DD-MMM-YYYY');
};

export const fmtDateRange = (from, to) => {
  if (!from || !to) return '—';
  return `${moment(from).format('DD-MMM')} to ${moment(to).format('DD-MMM YYYY')}`;
};

export const fmtUpdatedAt = (iso) => {
  if (!iso) return '—';
  return moment(iso).format('HH:mm') + ' local';
};

export const rateColor = (rate) => {
  if (rate >= 90) return BRAND_TEAL;
  if (rate >= 80) return '#B38600';
  if (rate >= 70) return '#BD5730';
  return '#C4001F';
};

export const completionRail = (rate) => {
  if (rate >= 90) return 'good';
  if (rate >= 75) return 'warn';
  return 'bad';
};

export const downtimeRail = (minutes, activeDays = 1) => {
  const avg = minutes / Math.max(activeDays, 1);
  if (avg > 90) return 'bad';
  if (avg > 60) return 'warn';
  return 'good';
};

export const submitRail = (pct) => {
  if (pct >= 95) return 'good';
  if (pct >= 85) return 'warn';
  return 'bad';
};

export const addDays = (dateStr, n) => moment(dateStr).add(n, 'days').format('YYYY-MM-DD');

export const stepAnchorDate = (anchorDate, periodType, direction) => {
  const unit = periodType === 'year' ? 'year' : periodType === 'quarter' ? 'quarter' : 'month';
  return moment(anchorDate).add(direction, unit).format('YYYY-MM-DD');
};

export const shiftLabel = (shift) => (shift === 0 || shift === '0' ? 'Day' : 'Night');

export const resolveDailySowId = (sowId, pipelines = []) => {
  if (sowId != null && sowId !== 'all') return Number(sowId);
  const first = pipelines[0];
  return first ? first.sowId : null;
};

/** Compact duration for shift-overview charts, e.g. "38m", "1h 8m". */
export const fmtMinShort = (minutes) => {
  if (minutes == null || Number.isNaN(Number(minutes))) return '—';
  const m = Math.round(Number(minutes));
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (h > 0 && r > 0) return `${h}h ${r}m`;
  if (h > 0) return `${h}h`;
  return `${r}m`;
};

const percentile = (sorted, p) => {
  if (!sorted.length) return null;
  const idx = (p / 100) * (sorted.length - 1);
  const lower = Math.floor(idx);
  const upper = Math.ceil(idx);
  if (lower === upper) return sorted[lower];
  return Math.round(sorted[lower] + (sorted[upper] - sorted[lower]) * (idx - lower));
};

/** Derive fastest / slowest / spread / P25 / P75 / P90 from cycle-time bars. */
export const cycleTimeBarStats = (bars = []) => {
  const times = bars
    .map((b) => b.cycleTimeMinutes)
    .filter((t) => t != null && !Number.isNaN(Number(t)))
    .map(Number)
    .sort((a, b) => a - b);
  if (!times.length) return null;
  return {
    fastest: times[0],
    slowest: times[times.length - 1],
    spread: times[times.length - 1] - times[0],
    p25: percentile(times, 25),
    p75: percentile(times, 75),
    p90: percentile(times, 90),
  };
};
